(function () {
  if (customElements.get('ce-localization') !== undefined) {
    return;
  }

  class Localization extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        form: '[data-localization-form]',
      };

      this.elements = null;

      this.handleChange = this.handleChange.bind(this);
    }

    parsedCallback() {
      this.elements = {
        form: this.querySelector(this.selectors.form),
      };

      this.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
    }

    handleChange() {
      this.elements.form.submit();
    }
  }

  customElements.define('ce-localization', Localization);
})();
